export enum BrandId {
    // aka "Tech"
    ElliotBrowne = 1,
    // aka "Finance"
    BigFour = 2
}